module.exports = __webpack_public_path__ + "img/ava3.9cbad8bf.png";